import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from './en-US';
import ptBR from './pt-BR';
import esES from './es-ES';

i18next.use(initReactI18next).init({
    lng: 'en-US', // Default language
    fallbackLng: 'en-US',
    debug: false,
    resources: {
        'en-US': {
            translation,
        },
        'pt-BR': {
            translation: ptBR,
        },
        'es-ES': {
            translation: esES,
        },
    },
    interpolation: {
        escapeValue: false, // React already escapes values
    },
    // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
    // set returnNull to false (and also in the i18next.d.ts options)
    // returnNull: false,
});

export default i18next;